import {useState, useEffect} from 'react'
import {useCompanyContext} from '../compay/CompanyContext'

const AutoLogoutSuggestion = () => {
  const companyCtx = useCompanyContext()
  const status = companyCtx?.getAutoLogoutStatus?.data?.autoLogoutStatus?.[0]
  const [minutes, setMinutes] = useState(30)

  useEffect(() => {
    if (status?.timeoutMinutes) setMinutes(status.timeoutMinutes)
  }, [status?.timeoutMinutes])

  const handleCheckboxChange = (e) => {
    try {
      companyCtx.postAutoLogoutStatus.mutate({
        autoLogoutEnabled: e.target.checked,
        timeoutMinutes: minutes,
      })
    } catch (error) {
      console.log(error)
    }
  }

  const handleMinutesBlur = () => {
    if (status?.autoLogoutEnabled) {
      try {
        companyCtx.postAutoLogoutStatus.mutate({
          autoLogoutEnabled: true,
          timeoutMinutes: minutes,
        })
      } catch (error) {
        console.log(error)
      }
    }
  }

  const autoLogoutEnabled = status?.autoLogoutEnabled ?? false

  return (
    <div className='card p-5'>
      <h3 className='card-title'>Auto Logout</h3>
      <p>Automatically log out users after a period of inactivity?</p>
      <div className='form-check'>
        <input
          className='form-check-input'
          type='checkbox'
          id='autoLogoutCheckbox'
          onChange={handleCheckboxChange}
          checked={autoLogoutEnabled}
        />
        <label className='form-check-label' htmlFor='autoLogoutCheckbox'>
          Yes, enable auto logout on inactivity
        </label>
      </div>
      {autoLogoutEnabled && (
        <div className='mt-3 d-flex align-items-center gap-3'>
          <label className='fw-bold col-form-label'>Timeout (minutes):</label>
          <input
            type='number'
            className='form-control'
            style={{width: 100}}
            value={minutes}
            min={1}
            max={480}
            onChange={(e) => setMinutes(Math.max(1, parseInt(e.target.value) || 1))}
            onBlur={handleMinutesBlur}
          />
          <span className='text-muted' style={{fontSize: 12}}>
            Users will be logged out after {minutes} min of inactivity.
          </span>
        </div>
      )}
    </div>
  )
}

export default AutoLogoutSuggestion
